module.exports = __webpack_public_path__ + "static/media/notify-showmore.2230c37c.svg";